import { SearchOutlined } from '@ant-design/icons';
import { Select, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { normalize } from '../../utils/normalizeWords';

interface OptionData {
  key: string;
  value: string;
  labelText: string;
  subValues: [string, string, string];
}

interface FormSelectCustomTwoRowPerOptionProps {
  placeHolder: string;
  options: OptionData[];
  onSearchSelected: (val: any) => void;
  autoSelectedLabel?: string;
  resetBasketSelection?: () => void;
  value?: string;
  onChange?: (val: string | undefined) => void;
  loading?: boolean;
}

const FormSelectCustomTwoRowPerOption: React.FC<FormSelectCustomTwoRowPerOptionProps> = ({
  placeHolder,
  options,
  onSearchSelected,
  autoSelectedLabel,
  resetBasketSelection,
  value,
  onChange,
  loading,
}) => {
  const { t } = useTranslation(['price', 'form']);
  const [search, setSearch] = useState('');

  const handleSelect = (val: string) => {
    const selected = options.find((option) => option.value === val);

    if (selected) {
      onChange?.(val);
      onSearchSelected(selected.labelText);
    }
  };

  const handleClear = () => {
    onChange?.(undefined);
    onSearchSelected('');
    resetBasketSelection?.();
  };

  return (
    <Select
      showSearch
      placeholder={loading ? t('form:loadingData') : t(`${placeHolder}`)}
      disabled={loading}
      loading={loading}
      onSearch={(value) => setSearch(value)}
      onSelect={handleSelect}
      value={value}
      notFoundContent={
        loading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              padding: '8px',
            }}
          >
            <Spin size="small" />
            <span>{t('form:loadingData')}</span>
          </div>
        ) : (
          t('form:noData')
        )
      }
      filterOption={(input, option) =>
        normalize((option?.value as string) ?? '')
          .toString()
          .toLowerCase()
          .includes(normalize(input.toLowerCase()))
      }
      suffixIcon={loading ? undefined : <SearchOutlined className="text-gray-400" />}
      optionLabelProp="label"
      allowClear
      onClear={handleClear}
    >
      {/* {filteredOptions.map((option) => (
        <Select.Option key={option.value} value={option.value}>
          <div>
            <div className="font-bold">{option.labelText}</div>
            <div>
              {option.subValues.map((value, index) => (
                <span key={index}>
                  {index === 0 ? value : ` • ${value}`}
                  {index < option.subValues.length - 1 && <span>&nbsp;&nbsp;</span>}
                </span>
              ))}
            </div>
          </div>
        </Select.Option>
      ))} */}
      {options.map((option) => (
        <Select.Option key={option.key} value={option.value}>
          <div>
            <div className="font-bold">{option.labelText}</div>
            <div>
              {option.subValues.map((value, index) => (
                <span key={index}>
                  {index === 0 ? value : ` • ${value}`}
                  {index < option.subValues.length - 1 && <span>&nbsp;&nbsp;</span>}
                </span>
              ))}
            </div>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

export default FormSelectCustomTwoRowPerOption;
